export default __webpack_public_path__ + "static/media/category_13.079a9f74.png";